import { z } from "zod";

export const offerEditSchema = z.object({
    title: z.string().min(3, "Title is required"),
    code: z.string().optional(),
    discountType: z.enum(["percentage", "fixed"]),
    status: z.enum(["pending", "active", "expired", "scheduled"]),
    discountValue: z.number().min(1),
    minOrderValue: z.number().min(0),
    maxDiscountValue: z.number().min(0),
    startDate: z.string(),
    endDate: z.string(),
    conditions: z.string().optional(),
    autoApply: z.boolean(),
    isDraft: z.boolean(),
})